import API from 'js/lib/api';

export default API('/api/grpc/paymentprocessor/v1beta2/SubscriptionProcessorAPI', {
  type: 'rest',
});
